
const digest = '93f2821d498a8587538fbc5043000b5a8e926536c42901df30f09a4eb9e76811';
const classes = {"wrapper":"_wrapper_1hu65_1","controls":"_controls_1hu65_6","filter":"_filter_1hu65_17","resetButton":"_resetButton_1hu65_25"};
const css = `._wrapper_1hu65_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
}
._wrapper_1hu65_1 ._controls_1hu65_6 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #eaedf3;
  border-top: 0;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 14px 34px;
  flex-wrap: wrap;
}
._wrapper_1hu65_1 ._controls_1hu65_6 ._filter_1hu65_17 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  max-width: 500px;
  flex-grow: 1;
}
._wrapper_1hu65_1 ._controls_1hu65_6 ._filter_1hu65_17 ._resetButton_1hu65_25 {
  min-width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  